import React from 'react';

export default {
  width: 30,
  height: 14,
  content: (
    <path d="M0 7.059C.001 2.64 3.131.003 8.373 0l16.204.026c.422 0 1.914.072 3.314 1C28.853 1.665 30 2.882 30 5.057v.005c0 2.226-1.067 3.435-1.963 4.058-1.289.896-2.789.992-3.374.992l-16.295-.024c-.602 0-2.016.001-2.987-.922-.593-.564-.894-1.344-.894-2.316v-.006c0-1.834 1.454-2.93 3.888-2.932l16.226-.008.002 1.907-16.226.008c-1.867.001-1.884.706-1.884 1.018v.011c0 .45.103.775.307.969.383.364 1.183.363 1.568.363l16.297.024c.387 0 1.376-.06 2.187-.624.758-.526 1.142-1.374 1.142-2.519v-.003c0-1.087-.42-1.917-1.251-2.468-.732-.486-1.625-.657-2.167-.657L8.372 1.907c-2.376.001-6.365.672-6.366 5.151 0 4.161 3.46 5.035 6.362 5.035l13.428-.04.006 1.907-13.43.04C3.05 14 0 11.47 0 7.059z" />
  )
};
